import { createAsyncThunk } from '@reduxjs/toolkit'
import { ColumnFiltersState } from '@tanstack/react-table'
import { Axios } from 'api/axios'
import axios from 'axios'
import { API_ENDPOINT } from 'helpers/Endpoints/endpoints'
import { FilterBuilder } from 'helpers/ThunkHelper/FilterBuilder'
const API_URL = process.env.REACT_APP_BASE_URL
const headers = {
  'Content-Type': 'application/json'
}

export interface Organisation {
  id?: number
  packageName: string
  districtCode: string
  districtName: string
  state: string
  status: boolean
  createBy?: string
  updatedBy?: string
  createDate?: string
  updateDate?: string
}
export interface PaginatedResponse<T> {
  count: number
  total_pages: number
  next: string | null
  previous: string | null
  results: T[]
}

export const fetchUser = createAsyncThunk(
  'user/fetchUsers',
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters
  }: {
    page: number
    pageSize: number
    search?: string
    sort?: string
    order?: 'asc' | 'desc' | ''
    filters?: ColumnFiltersState
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search.trim());
      if (sort) {
        const mappedSort = sort === 'user_type_name' ? 'user_type_name' : sort;
        const orderingValue = order === "desc" ? `-${mappedSort}` : mappedSort;
        params.append("ordering", orderingValue);
      }

      // Transform TanStack Table filters from { id, value } to { filterField, filterValue } format
      const transformedFilters = (filters ?? []).map((filter: any) => ({
        filterField: filter.id || filter.filterField,
        filterValue: filter.value !== undefined ? filter.value : filter.filterValue,
      }));

      const filterPayload = FilterBuilder(transformedFilters);

      const body = {
        filters: filterPayload,
      };
      const response: any = await Axios.post(`${API_ENDPOINT.USER_MANAGEMENT.USER.LIST}?${params.toString()}`, body);
      console.log("body in fetchUser", response)

      const responseData = response.data
      return {
        data: responseData?.data || responseData?.results || [],
        rowCount: responseData?.total_records || responseData?.count || 0
      }
    } catch (error: any) {
      console.error('fetchUser error:', error.response?.data || error.message)
      throw new Error('Failed to fetch Users')
    }
  }
)

export const createUser = createAsyncThunk(
  'user/createUser',
  async (userData: any, { rejectWithValue }) => {
    try {
      const response = await Axios.post(`/users/register/`, userData, {
        headers
      })

      return response.data // adjust depending on your backend's response format
    } catch (err: any) {
      console.error('Create User Error:', err)
      return rejectWithValue(err.response?.data || 'Failed to create user')
    }
  }
)

export const fetchOrganisationById = createAsyncThunk(
  'organisation/fetchById',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(API_ENDPOINT.USER_MANAGEMENT.ORGANIZATION.DETAIL(id))
      console.log('resp to update Id : ', response)
      return response
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || 'Failed to fetch organisations by ID'
      )
    }
  }
)

export const updateOrganisation = createAsyncThunk(
  'organisation/updateOrganisation',
  async (packageData: any) => {
    // const token = localStorage.getItem("authToken");
    // if (!token) {
    //   throw new Error("No authentication token found");
    // }
    console.log('pkgData:', packageData)
    const response: any = await Axios.put(
      `/${API_URL}/organization/${packageData.id}/update/`,
      packageData
    )
    console.log('updateOrganisation response:', response)
    return response
  }
)
export const updateStatusInOrg = createAsyncThunk(
  'organisation/updateOrganisation2',
  async (packageData: any) => {
    console.log('pkgData:', packageData)
    const response: any = await Axios.put(
      API_ENDPOINT.USER_MANAGEMENT.ORGANIZATION.UPDATE(packageData.id),
      packageData
    )
    console.log('updateOrganisation response:', response)
    return response
  }
)

export const addOrganisation = createAsyncThunk(
  'organisation/addOrganisation',
  async (packageData: any) => {
    const response = await Axios.post(API_ENDPOINT.USER_MANAGEMENT.ORGANIZATION.CREATE, packageData)
    console.log('addOrganisation response:', response)
    console.log('addOrganisation response:', response.data)
    return response.data
  }
)

export const deleteOrganisation = createAsyncThunk(
  'packages/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      await Axios.delete(API_ENDPOINT.USER_MANAGEMENT.ORGANIZATION.DELETE(String(id)), { headers })
      return id
    } catch (err: any) {
      console.error('Delete error:', err)
      return rejectWithValue(err.response?.data?.message || err.message)
    }
  }
)

export const updateStatusInUsers = createAsyncThunk(
  `updateusers/updateStatusInUsers`,
  async (userData: any) => {
    const response = await Axios.put(
      API_ENDPOINT.USER_MANAGEMENT.USER.STATUS_UPDATE(userData?.user_id),
      { is_active: userData.is_active }
    )
    return response
  }
)

export const fetchDropdownByColumn = createAsyncThunk(
  'organization/fetchDropdownByColumn',
  async (columnId: string) => {
    let endpoint = ''

    switch (columnId) {
      case 'first_name':
      case 'last_name':
      case 'username':
        endpoint = API_ENDPOINT.USER_MANAGEMENT.USER.FILTER_DROPDOWN(columnId)
        break
      case 'organization_name':
        endpoint = API_ENDPOINT.ORGANIZATION.ALL_ORG
        break
      case 'industry_type':
      case 'org_city':
      case 'org_state':
      case 'org_pincode':
        // These organization dropdown endpoints may need to be added to endpoints.ts
        endpoint = `/organization/dropdown/${columnId}/`
        break
      default:
        throw new Error(`No dropdown endpoint for ${columnId}`)
    }

    const response = await Axios.get(endpoint, { headers })

    console.log('API Response for', columnId, '=>', response.data)

 
    if (['first_name', 'last_name', 'username'].includes(columnId)) {
      return {
        key: `${columnId}DropDown`,
        data: Array.isArray(response.data[columnId])
          ? response.data[columnId]
          : []
      }
    }

    if (columnId === 'organization_name') {
      return {
        key: 'orgDropDown',
        data: Array.isArray(response.data.data)
          ? response.data.data.map((item: any) => item.organization_name)
          : []
      }
    }

    return {
      key: `${columnId}DropDown`,
      data: Array.isArray(response.data[columnId])
        ? response.data[columnId]
        : []
    }
  }
)

//Exports csv file
// Exports department CSV file
export const exportUsersCSV = createAsyncThunk(
  'users/exportUsersCSV',
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('authToken');

      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: '*/*',
      };

      const response = await Axios.get('users/list/?export=excel', {
        headers,
        responseType: 'blob',
      });

      return {
        blob: response.data,
        filename:
          response.headers['content-disposition']
            ?.split('filename=')[1]
            ?.replace(/"/g, '') || 'users.csv',
      };
    } catch (err: any) {
      console.error('Export CSV error:', err);
      return rejectWithValue(err.message || 'Failed to export CSV');
    }
  }
);

export const UsersxportsCSV = async ({
search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();
  params.append("export", "excel");

  if (search) params.append("search", search.trim());

  // Transform TanStack Table filters from { id, value } to { filterField, filterValue } format
  const transformedFilters = (filters ?? []).map((filter: any) => ({
    filterField: filter.id || filter.filterField,
    filterValue: filter.value !== undefined ? filter.value : filter.filterValue,
  }));

  const filterPayload = FilterBuilder(transformedFilters);

  const body = {
    filters: filterPayload,
  };

  const response = await Axios.post(`${API_ENDPOINT.USER_MANAGEMENT.USER.EXPORT}?${params.toString()}`, body, {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename: `${
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "Users"
    }_${new Date().toISOString().split("T")[0]}.csv`,
  };
};

export const fetchAllUsersDropdown = createAsyncThunk(
  'user/fetchAllUserFormDropdowns',
    async (_,{ rejectWithValue }) => {
    try {
     const res =  await Axios.get(API_ENDPOINT.USER_MANAGEMENT.USER.DROPDOWN)
     console.log("response in users dropdown",res)
      return res.data.data
    } catch (err: any) {
      console.error('Delete error:', err)
      return rejectWithValue(err.response?.data?.message || err.message)
    }
  }
)



export const fetchALLUserFormDropdowns = createAsyncThunk(
  'user/fetchAllUserFormDropdowns',
  async () => {
    try {
      const urls = [
        // `/user-types/dropdown/`,
        API_ENDPOINT.USER_MANAGEMENT.ORGANIZATION.DROPDOWN,
        API_ENDPOINT.USER_MANAGEMENT.DEPARTMENT.DROPDOWN,
        API_ENDPOINT.USER_MANAGEMENT.TEAM.DROPDOWN,
        // API_ENDPOINT.USER_MANAGEMENT.ORGANIZATION.DROPDOWN
      ]
      const [userTypesRes, orgRes, departmentRes, teamsRes, stateRes] =
        await Promise.all(urls.map((url: any) => Axios.get(url, { headers })))
      // console.log(userTypesRes,"userTypesRes---------------1")
      console.log('userTypesRes.data:', userTypesRes.data)
      console.log(stateRes, 'state----------2', orgRes)
      console.log(orgRes, 'orgRes---------1')
      console.log(departmentRes, 'departmentsRes---------1')
      console.log("userTypesRes",userTypesRes)
      return {
       userTypes: Array.isArray(userTypesRes?.data?.data) ? userTypesRes.data.data : [],
        organizations: Array.isArray(orgRes?.data?.data)
          ? orgRes?.data?.data
          : [],
        departments: Array.isArray(departmentRes?.data?.data)
          ? departmentRes?.data?.data
          : [],
        teams: Array.isArray(teamsRes?.data?.data) ? teamsRes?.data?.data : [],
        states: Array.isArray(stateRes.data?.org_state)
          ? stateRes.data.org_state
          : []
      }
    } catch (err) {
      console.error('Error fetching user form dropdowns:', err)
      throw err
    }
  }
)


export const fetchTechnicianDropdown = createAsyncThunk(
  'user/fetchTechnicianDropdown',
  async (type:string) => {
    try {
      const response = await Axios.get(API_ENDPOINT.USER_MANAGEMENT.USER.GET_USER_DROPDOWN_BY_TYPE(type))
      console.log('response in users dropdown', response)
      return response.data.data
    } catch (err: any) {
      console.error('Delete error:', err)
      throw (err.response?.data?.message || err.message)
    }
  }
)
